import { render, staticRenderFns } from "./TileProductThroughput.vue?vue&type=template&id=6cb0c675"
import script from "./TileProductThroughput.vue?vue&type=script&lang=js"
export * from "./TileProductThroughput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports